import * as React from "react"
import { App } from "./app"
import { PADebug } from "./PADebug"
import { SelectionSetGW } from "./SelectionSetGW"
import { PageBrowser } from "./PageBrowser"

///////////////   ProjectView  ////////////////

/* ProjectView displays all projects saved by the logged in user and makes them accessible
   by a load button, and as well lets the user merge a saved project into the current one. */

export interface ProjectViewVm  {
    app: App
}

export interface ProjectViewStateVm {
    stage: string
}

export class ProjectView extends React.Component<ProjectViewVm, ProjectViewStateVm> {

    constructor(props: ProjectViewVm) {
        super(props)
        this.m_hoveredItem = -1
        this.m_pageBrowser = new PageBrowser()
        this.m_pageBrowser.initiate(this.props.app.state.resultGroupLength, this.props.app.state.resultGroupRange, "utvalg", "(Ingen utvalg funnet)")
        this.m_pageBrowser.connect(this.onUpdateFromPageBrowser.bind(this), this.GetTotalAmount.bind(this))
    }

    // 
    state = {
        stage: "initial"
    }

    // 
    componentWillMount() {
        this.props.app.GetCore().ConnectProjectView(this)
    }

    // Bottom scoop means the user moved the mouse below the project item list, and this actiom will un hover the bottom project item
    onBottomScoop() {
        this.props.app.GetCore().GetSelectionSetManager().SetHoveredProjectIndex(-1)
        this.forceUpdate()
    }

    // 
    onMouseLeave() {
        this.props.app.GetCore().GetSelectionSetManager().SetHoveredProjectIndex(-1)
        this.forceUpdate()
    }

    onUpdateFromPageBrowser() {
        this.forceUpdate()
    }

    GetTotalAmount() {
        return this.props.app.GetCore().GetSelectionSetManager().GetProjectAmount()
    }

    // 
    render() {
        const core = this.props.app.GetCore() 
        
        // Checks if the user wants to delete a saved project after clicking the delete button (cross)
        if (this.state.stage == "deleteQuestion") {
            return <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "calc(50% - 50px)", height: "1px" }}>
                </div>
                <div style={{ position: "relative", top: "80px", display: "flex", flexDirection: "column" }}>
                    <div>Er du sikker på at du vil</div>
                    <div>slette dette utvalg:</div>
                    <div>{this.m_itemToDelete.GetName()}</div>

                    <div style={{ position: "relative", top: "5px", display: "flex", flexDirection: "row" }}>
                        <div onClick={this.OnDeleteSure.bind(this)} style={{ backgroundColor: "grey", width: "64px", height: "30px", position: "relative", top: "20px", cursor: "pointer" }}>
                            <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                Slette
                            </div>
                        </div>

                        <div onClick={this.OnCansel.bind(this)} style={{ backgroundColor: "grey", width: "74px", height: "30px", position: "relative", top: "20px", left: "20px", cursor: "pointer" }}>
                            <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                Avbryt
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }

        if (this.state.stage == "savePreviousQuestion") {
            var chosenProjectTitle = "det ønskede utvalget"
            
            if ((this.props.app.GetCore().GetSelectedArticles().length > 0) || (this.props.app.GetCore().GetSelectedBuildParts().length > 0)) {

                return <div style={{ display: "flex", flexDirection: "row" }}>
                    <div style={{ width: "calc(50% - 130px)", height: "1px" }}>
                    </div>
                    <div style={{ position: "relative", top: "80px", display: "flex", flexDirection: "column" }}>
                        <div>Ønsker du å lagre endringerne på nåvarende utvalg før du åpner {chosenProjectTitle}?</div>

                        <div style={{ position: "relative", top: "5px", display: "flex", flexDirection: "row" }}>
                            <div onClick={this.OnSaveFirst.bind(this)} style={{ backgroundColor: "grey", width: "125px", height: "30px", position: "relative", top: "20px", cursor: "pointer" }}>
                                <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                    Lagre endringer
                                </div>
                            </div>

                            <div onClick={this.OnDiscardAndLoad.bind(this)} style={{ backgroundColor: "grey", width: "145px", height: "30px", position: "relative", top: "20px", left: "20px", cursor: "pointer" }}>
                                <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                    Ikke lagre endringer
                                </div>
                            </div>

                            <div onClick={this.OnCansel.bind(this)} style={{ backgroundColor: "grey", width: "74px", height: "30px", position: "relative", top: "20px", left: "40px", cursor: "pointer" }}>
                                <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                    Avbryt
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            }
        }

        if (this.state.stage == "mergingProject") {
            return <div style={{ marginLeft: "20px", marginTop: "20px" }}>Importerer utvalg...</div>
        }

        if (this.state.stage == "loadingProject") {
            return <div style={{ marginLeft: "20px", marginTop: "20px" }}>Lader utvalg...</div>
        }

        if (this.state.stage == "savingProject") {
            return <div style={{ marginLeft: "20px", marginTop: "20px" }}>Sparer utvalg...</div>
        }

        if (this.state.stage == "deletingProject") {
            return <div style={{ marginLeft: "20px", marginTop: "20px" }}>Sletter utvalg...</div>
        }
        
        return <div onMouseLeave={this.onMouseLeave.bind(this)}>

            {/* Top margin: */} 
            <div style={{height:"19px", width:"100%"}}> 
            </div>

            {/* Title: */}
            <div style={{ height: "52px",fontSize: "28px", fontWeight: "bold", marginLeft:"33px" }}>
                Utvalg:
            </div>

            <div style={{ height: "82px", marginLeft: "35px" }}>
                {this.m_pageBrowser.render(false)}
            </div>
            
            {/* column tops: */}
            <div onMouseEnter={this.onMouseLeave.bind(this)} style={{ display: "flex", flexDirection: "row", height:"30px" }}> 
                <div style={{ width: "33px" }}></div>
                <div style={{ width: "52px", fontSize: "16px" }}>Åpne</div>
                <div style={{ width: "120px", fontSize: "16px", position:"relative", left:"10px" }}>Slå sammen</div>
                <div style={{ width: "68px", fontSize: "16px" }}>Slette</div>
                <div style={{ width: "322px", fontSize: "16px" }}>Tittel</div>
                <div style={{ width: "170px", fontSize: "16px" }}>Senest endret</div>
            </div>

            {/* Projects list: */}
            <div>
                {core.GetSelectionSetManager().RenderProjects(this.m_pageBrowser.GetCurrentStartPosition(), this.m_pageBrowser.GetCurrentEndPosition())}
            </div>

            {/* bottom scoop: */}
            <div style={{ width: "100%", height: "50px" }} onMouseEnter={this.onBottomScoop.bind(this)}>
            </div>

            <div style={{ height: "52px", marginLeft: "35px" }}>
                {this.m_pageBrowser.render(true)}
            </div>
        </div>
    }

    SetHoveredItem(index: number) {
        this.m_hoveredItem = index
    }

    GetHoveredItem() {
        return this.m_hoveredItem
    }
    
    OnDeleteSure() {
        this.props.app.GetCore().GetSelectionSetManager().DeleteProject(this.m_itemToDelete)
        this.setState({ stage: "deletingProject" })
    }
    
    OnCansel() {
        this.setState({ stage:"initial"})
    }

    SetItemToDelete(set: SelectionSetGW) {
        this.m_itemToDelete = set
    }

    OnSaveFirst() {
        const manager = this.props.app.GetCore().GetSelectionSetManager()

        if (manager.GetCurrentProjectName() == this.m_itemToLoad.GetName()) {
            manager.SaveProject(manager.GetCurrentProjectName(), this.OnAfterSaveWithSameNameStepOne.bind(this))
        }
        else {
            manager.SaveProject(manager.GetCurrentProjectName(), this.OnDiscardAndLoad.bind(this))
        }

        this.setState({ stage: "savingProject" })
    }

    OnDiscardAndLoad() {
        this.props.app.GetCore().ClearAllQRArticles()
        this.props.app.GetCore().ClearAllQRBuildParts()
        this.props.app.GetCore().LoadAccountData(this.OnAfterAccountRefresh.bind(this))
    }

    OnAfterSaveWithSameNameStepOne() {
        this.props.app.GetCore().LoadAccountData(this.OnAfterSaveWithSameNameStepTwo.bind(this))
    }

    OnAfterSaveWithSameNameStepTwo() {
        this.props.app.setState({ DisplayMode: this.props.app.DMode.QReport })
    }

    OnAfterAccountRefresh() {
        this.props.app.GetCore().GetSelectionSetManager().loadProject(this.m_itemToLoad)
        this.setState({ stage: "loadingProject" })
    }

    public SetItemToLoad(set: SelectionSetGW) {
        this.m_itemToLoad = set
    }
    
    private m_hoveredItem: number
    private m_itemToDelete: SelectionSetGW
    private m_itemToLoad: SelectionSetGW
    private m_pageBrowser: PageBrowser 
}


// WEBPACK FOOTER //
// ./client/view/ProjectView.tsx